import type { FaireProductEntity } from "../../entity_types/product";

export const p_43zh9hmtew: FaireProductEntity = {
  token: "p_43zh9hmtew",
  type: "product",
  name: 'Little "Sophie Scarf"',
  brandToken: "b_2f4gf52uef",
  brandName: "Calie Paris",
  imageUrl:
    "https://cdn.faire.com/fastly/57e7d0e0063df4861b363160938ee7e67492e4b1acd4c06c507a08ec0592a5ab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63b3371d3c51086c44c13ee754217dac0ce84d6773a68c30c069e22a6e5a0e9c.jpeg",
    "https://cdn.faire.com/fastly/efe6f16807527c44ced02dc17dc6fe6faeb638c27dc3d03cad56711e16cb0099.jpeg",
    "https://cdn.faire.com/fastly/815cb97ce62d0dbfe6d60d15cfbaed934464ae79568b95af63d1555d045b39c6.jpeg",
    "https://cdn.faire.com/fastly/2860beb9587e2f23417db1f2c24f05a634b50d3102fb4f9d94427df2fc69ffe1.jpeg",
    "https://cdn.faire.com/fastly/132700f03bc8392007742d192b844f6e00fcf3f9e3a8aa065102993018430bed.jpeg",
    "https://cdn.faire.com/fastly/90b8a71cd52b3a7356b5a5ca30641f9c1c505188d4f240cc237bffa01f443a2e.jpeg",
    "https://cdn.faire.com/fastly/beea21cc6dde17c6aec44bda00e87fbdf269f30036630bd3c9fd141fbed078b9.jpeg",
    "https://cdn.faire.com/fastly/c04cee9e615c03b93d2646ce6e63f68eb92bd67fadf3d19aa55e02daf7e7b6e1.jpeg",
    "https://cdn.faire.com/fastly/012a12084a951991c0127481fa89e1d811e6ba8b673393586e14e092c5f141ec.jpeg",
    "https://cdn.faire.com/fastly/c355e10717a87b9d4e458f20dd5e31be414148e504acb3ac14b19a31c4f91fd5.jpeg",
    "https://cdn.faire.com/fastly/b66860bccfe5cfbc31b45da6f33d4d5eb97e1ad2c376d293fdfa84bdb23b8fe8.jpeg",
    "https://cdn.faire.com/fastly/ae4d5857d08a29d431af54dee63b7107326ad5877a56438ea8dd185593bbef38.jpeg",
    "https://cdn.faire.com/fastly/6dfa952a703fb5d4d0dcd14df729fd9638cf9e7ad2200fd12550a1437f7d41f7.jpeg",
    "https://cdn.faire.com/fastly/bc970791a268d3957af57f321c1170d40847741f29913b62c7354d989be66c9a.jpeg",
    "https://cdn.faire.com/fastly/e80f0be0e7f5d15e07a2008cc5a23bcea5cfacb54bff67f4304e32f7cc8065c6.jpeg",
    "https://cdn.faire.com/fastly/c21723b9ece86d3b9d6d7eaf76848336ff657ff1f8f9739d138f4490051ab0d1.jpeg",
    "https://cdn.faire.com/fastly/006d2ca628675ca1476b24f1e27838a62e4a0f2af38496531ade865864aff993.jpeg",
    "https://cdn.faire.com/fastly/bced8ec2c36aafcf6a38e1fa862dd9a9f68d96032665341d280ade75a89ee6df.jpeg",
    "https://cdn.faire.com/fastly/5dc81e7763cb4010aeac178eff98f9f68dd7a3a45ff2d5a5b48f42b17181a289.jpeg",
    "https://cdn.faire.com/fastly/5071a997ab2fb7435af4bb6e7721a690780c34f703bdb2f4758f077524f8c45f.jpeg",
    "https://cdn.faire.com/fastly/b596f8ea9979309b4c97ab1ea120d9a2618f705cc091eaf633680eb824b2e2a0.jpeg",
    "https://cdn.faire.com/fastly/9c97880106d017bb37919fabe84d2d547709723285eea3a90132b6d7d64fc46b.jpeg",
    "https://cdn.faire.com/fastly/b39656b1b8b47adffeca9da970896e3871f459b6a28472cee065aa3daa104902.jpeg",
    "https://cdn.faire.com/fastly/b8b7f636579b6c5dcbd7d522e0e3fe103185c6d127e09e48e60472aa78c64c2f.jpeg",
    "https://cdn.faire.com/fastly/cc5006fcbe2da4d90576736c3cca06212386f04ebaca4040b55a8cee856a3c5d.jpeg",
    "https://cdn.faire.com/fastly/e2d8a7eac50712fe40b069785881e65b0b822bce34861f3676ce3c3120c702ec.jpeg",
    "https://cdn.faire.com/fastly/774bc61c48207c9f2a6666ef453863fc442c3994a2639c49f1337877127fc632.jpeg",
    "https://cdn.faire.com/fastly/f85dfa882bd0dc39f59f2ed330b4858105e1e789291a10a62f61a5880c080511.jpeg",
    "https://cdn.faire.com/fastly/de5f727facbded0049097b031fb5c2488bc9cd6b2884c541d8a9b12368d5a729.jpeg",
    "https://cdn.faire.com/fastly/df552f3612212efac05d8f5362c32bb6b983657fb9e157971d9c9890db0d319d.jpeg",
    "https://cdn.faire.com/fastly/9025c4f65ed6822b7d7ee358facd73756e7ba914f758edbc4dc8589b14380b0c.jpeg",
    "https://cdn.faire.com/fastly/e46b9f7b8f45f869c3521127c654fb70d7f16575331381361e676670a25e955e.jpeg",
    "https://cdn.faire.com/fastly/962359a41c2f145fd269e186fcfbca3b0b4604fa07912e2e30f59bb25c0bd6b3.jpeg",
    "https://cdn.faire.com/fastly/d1e65d8b25d339ba14cbf6907de7ed4af610474f276e41afe856ccf95e775c15.jpeg",
    "https://cdn.faire.com/fastly/9d12111bdec2708373031a0876667be3382c9dae4635aa9dd38e220e0928a50a.jpeg",
    "https://cdn.faire.com/fastly/4381ac49ecc9a91ab48667fb8ec7a6bf0e4e6587aee860133af3eef2510606aa.jpeg",
    "https://cdn.faire.com/fastly/c4cd0f264f18f7e69a4a5aafc7791336d2250c33861e2f1a34ea43295189a0db.jpeg",
    "https://cdn.faire.com/fastly/5b81362a942128a08a10b74dfa5d3ccdb8c67a35d50a2f080acd7191bc695666.jpeg",
  ],
  priceDollars: 14.03,
  description:
    "You've must seen it a lot lately on the social medias, this small triangular scarf, is a sensation among Scandinavian girls. \n\n10% Cashmere, 40% Merinos wool, 30% Viscose, 20% Recycled Polyamide",
  tags: [],
  msrpDollars: 29.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:42.562Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
